import app from 'flarum/forum/app';

// Links to the PixMMO website and socials, shared by the header and footer.

export const DISCORD_URL = 'https://discord.gg/Rjnjp7URG5';
export const SOCIALS = [{
  key: 'discord',
  label: 'Discord',
  icon: 'fab fa-discord',
  href: DISCORD_URL
}, {
  key: 'reddit',
  label: 'Reddit',
  icon: 'fab fa-reddit-alien',
  href: 'https://www.reddit.com/r/PixMMO/'
}, {
  key: 'x',
  label: 'X / Twitter',
  icon: 'fab fa-x-twitter',
  href: 'https://x.com/PiXMMO'
}, {
  key: 'instagram',
  label: 'Instagram',
  icon: 'fab fa-instagram',
  href: 'https://www.instagram.com/pixmmo/'
}, {
  key: 'tiktok',
  label: 'TikTok',
  icon: 'fab fa-tiktok',
  href: 'https://www.tiktok.com/@pixmmo'
}, {
  key: 'youtube',
  label: 'YouTube',
  icon: 'fab fa-youtube',
  href: 'https://www.youtube.com/@pixmmoyt'
}];

/** The PixMMO website (setting "PixMMO website"), without a trailing slash. */
export function siteUrl() {
  return String(app.forum.attribute('pxSiteUrl') || 'https://www.pixmmo.com').replace(/\/+$/, '');
}

/** A page on the PixMMO website. */
export function sitePage(path) {
  return `${siteUrl()}${path}`;
}

/** Header links: game pages on the PixMMO website, then Discord. */
export function headerLinks() {
  return [{
    key: 'news',
    icon: 'fas fa-newspaper',
    href: sitePage('/news')
  }, {
    key: 'wiki',
    icon: 'fas fa-book-open',
    href: sitePage('/wiki')
  }, {
    key: 'leaderboard',
    icon: 'fas fa-trophy',
    href: sitePage('/game/players')
  }, {
    key: 'killboard',
    icon: 'fas fa-skull',
    href: sitePage('/killboard')
  }, {
    key: 'discord',
    icon: 'fab fa-discord',
    href: DISCORD_URL
  }];
}